import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router"
import config from '../../config.json'
import { ADVERTISEMENT } from '../../constants/itemTypes'
import toJS from '../../hoc/toJS'
import { advertisementsDeleteItem } from '../../actions'
import getData from '../../functions/getData'
import { AUTH_CAPS, PROGRAM_ADVERTISEMENTS_ITEMS } from '../../constants/state'
import { ADVERTISEMENT_HOME_BANNER, ADVERTISEMENT_HOME_BANNER_SINGLE, ADVERTISEMENT_MAIN_SLIDER } from '../../constants/advertisementTypes'
import selectionTypes from '../../constants/itemSelectionsDisplayTypes'
import ListDrag from '../../components/DragAndDropList/presents/ListDrag'
import dndItemTypes from '../../constants/dndItemTypes'
import ProgramDragDropItemSwitch from '../../components/PageEditSelection/ProgramDragDropItemSwitch'
import canEditProgram from '../../functions/canEditProgram'

const mapStateToProps = state => ({
    items: getData(state, PROGRAM_ADVERTISEMENTS_ITEMS),
    caps: getData(state, AUTH_CAPS)
})

const mapDispatchToProps = (dispatch, ownProps) => ({    
    removeItem: (itemID) => {
        dispatch(advertisementsDeleteItem(itemID))
    }
})

const ProgramListAdvertisementContainer = ({
    titleTransId, 
    buttonTextTransId,
    className, 
    items, 
    match, 
    caps,
    isAllOpen,
    setAllOpen,
    removeItem,
}) => {
    const { selectionId, selectionType } = match.params

    const itemTypes = selectionTypes.MAIN === selectionType
        ? [ADVERTISEMENT_MAIN_SLIDER]
        : selectionTypes.ADVERTISEMENT === selectionType
        ? [ADVERTISEMENT_HOME_BANNER, ADVERTISEMENT_HOME_BANNER_SINGLE]
        : []

    if(0 === itemTypes.length)  {
        return ''
    }

    const basicUrl = `${config.routes.program.path}/${selectionType}/${selectionId}`
    const pathnameAdd = `${basicUrl}/${ADVERTISEMENT}/addItem/form`
    const canEdit = canEditProgram(caps)

    const order = []
    const filteredItems = {}

    Object.keys(items).map(itemId => {
        const item = items[itemId]

        if(itemTypes.includes(item.type)) {
            order.push(itemId)
            filteredItems[itemId] = item
        }
    })

    return <ListDrag
        titleTransId={titleTransId}
        buttonTextTransId={buttonTextTransId}
        listId={'advertisement-'  + selectionId}
        dndType={dndItemTypes.PROGRAM_ITEM_AD}
        className={className}

        type={ADVERTISEMENT}
        order={order}
        items={filteredItems}

        ChildSwitchItem={ProgramDragDropItemSwitch}

        params={false}
        basicUrl={basicUrl}

        
        defaultIsOpen={isAllOpen}
        setAllOpen={setAllOpen}

        canEdit={canEdit}
        canDelete={canEdit}
        pathnameAdd={pathnameAdd}
        deleteItem={removeItem}
    />
}

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(ProgramListAdvertisementContainer)